export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'boltPhotobooth': { id: 'boltPhotobooth', page: 'photobooth', getter: () => import(/* webpackChunkName: 'boltPhotobooth' */ 'components/bolt/photobooth/photobooth') },
	'reserveSeating': { id: 'reserveSeating', page: 'text', getter: () => import(/* webpackChunkName: 'reserveSeating' */ 'components/bolt/text/text') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'reserveSeating', getter: () => import(/* webpackChunkName: "reserveSeating" */ 'components/bolt/text/text'), component: 'text' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
